import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { PRETTY_BLUE } from "../trips/form/BorderWithLabel";
import { GENERATING_ROUTE, ROUTE_TIME_STRING } from "../UserVisibleStrings";

interface ThumbnailTimerProps
{
    startTime: Date | undefined;
}

/**
 * ThumbnailTimer component displays a timer counting up from the given startTime
 *
 * @param {ThumbnailTimerProps} props - The props for the component.
 * @param {Date | undefined} props.startTime - The start time from which the timer counts up.
 * @returns {JSX.Element} - The rendered component.
 */
const ThumbnailTimer: React.FC<ThumbnailTimerProps> = ( { startTime } ) =>
{
    const [ timeElapsed, setTimeElapsed ] = useState( Math.floor( ( startTime ? new Date().getTime() - startTime?.getTime() : 0 ) / 1000 ) );

    const [ currentState, setCurrentState ] = useState< "generating" | "routes">( "generating" );
    const [ opacity, setOpacity ] = useState<boolean>( true );

    useEffect( () =>
    {
        if ( startTime )
        {
            const startTimeMillis = startTime.getTime();
            const interval = setInterval( () =>
            {
                const currentTime = new Date().getTime();
                const elapsedTime = Math.floor( ( currentTime - startTimeMillis ) / 1000 ); // Convert to seconds
                setTimeElapsed( elapsedTime );

            }, 1000 );

            return () => clearInterval( interval );
        }
    }, [ startTime ] );

    useEffect( () =>
    {
        const textSwitchInterval = setInterval( () =>
        {
            setOpacity( false );
            setTimeout( () =>
            {
                setCurrentState( ( prevState ) => ( prevState === "generating" ? "routes" : "generating" ) );
                setOpacity( true );
            }, 3000 );
        }, 10000 );

        return () => clearInterval( textSwitchInterval );
    }, [] );

    /**
     * Formats the elapsed time in seconds to MM:SS format.
     *
     * @param {number} seconds - The time in seconds.
     * @returns {string} - The formatted time string.
     */
    const formatTime = ( seconds: number ) =>
    {
        const mins = Math.floor( seconds / 60 );
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    return (
        <div
            style = {{
                height: "110px",
                width: "100%",
                backgroundColor: PRETTY_BLUE,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Typography
                variant = "h6"
                style = {{
                    color: opacity ? "white" : PRETTY_BLUE,
                    transition: "color 3s",
                    marginBottom: "10px"
                }}
            >
                {currentState === "generating" ? GENERATING_ROUTE
                    : ROUTE_TIME_STRING}
            </Typography>
            <Typography variant = "h6" style = {{ color: "white" }}>
                { formatTime( timeElapsed )}
            </Typography>
        </div>
    );
};

export default ThumbnailTimer;
